
<template>
    <div class="settalk">
        <el-dialog title="设置个人话术库" class="settaildalog" :visible.sync="showaddtalk" width="900px" :before-close="handleClose">

            <div class="settlakbox">
                <div class="selone">
                    <div class="lists" v-if="bannerList1.length ==0">&nbsp;&nbsp;&nbsp;&nbsp;暂无分组</div>
                    <el-scrollbar style="height: 100%;" v-if="bannerList1.length !=0">
                        <draggable v-model="bannerList1" :options="{group:'people',animation:150}" @start="drag=true"
                            @end="dragend">
                            <div class="lists" v-for="(item,index) in bannerList1" :key="index" @click="selone(item.id)"
                                :class="{'active':activeindexone == item.id}">
                                <i class="iconfont">&#xe627;</i>
                                {{item.name}}
                                <i class="iconfont fr" @click.stop="deletteam(item.id)">&#xe6a6;</i>
                                <i class="iconfont fr" @click.stop="editteam(item.id,item.name)">&#xe6b1;</i>
                            </div>
                        </draggable>
                    </el-scrollbar>
                    <a href="javascript:;" class="addbtn" @click="addteam">
                        + 添加分组
                    </a>
                </div>
                <div class="selone seltwo">
                    <el-scrollbar style="height: 100%;">
                        <ul>
                            <li v-if="talklistsdata.length==0">
                                无内容
                            </li>
                            <li v-else :class="{'active':activeindextwo == item.id}" v-for="(item,index) in talklistsdata"
                                :key="index" @click="seltwo(item.id)">
                                {{item.templateTitle}}
                                <i class="iconfont fr" @click.stop="delettit(item.id)">&#xe6a6;</i>
                                <i class="iconfont fr" @click.stop="edittit(item.id,item.name,index)">&#xe6b1;</i>
                            </li>
                        </ul>
                    </el-scrollbar>
                    <a href="javascript:;" class="addbtn" @click="addtalkfun">
                        + 添加话术
                    </a>
                </div>

                <div class="selone selthree">
                    <el-scrollbar style="height: 100%;">
                        <div class="selcon" v-if="seldata.templateStatementType ==5">
                            <div class="filecon">
                                <b class="iconfont doc" v-if="seldata.type =='doc'">&#xe737;</b>
                                <b class="iconfont xls" v-if="seldata.type =='xls'">&#xe732;</b>
                                <b class="iconfont ppt" v-if="seldata.type =='ppt'">&#xe731;</b>
                                <b class="iconfont pdf" v-if="seldata.type =='pdf'">&#xe733;</b>
                                <p>{{seldata.fileName}}</p>
                                <span>{{seldata.fileSize}}</span>
                            </div>
                        </div>

                        <div class="selcon" v-if="seldata.templateStatementType ==1">
                            <div class="txtcon">
                                {{seldata.templateContent}}
                            </div>
                        </div>

                        <div class="selcon imgcon" v-if="seldata.templateStatementType ==2">
                            <img :src="seldata.templateContent" alt="">
                        </div>

                        <div class="selcon videocon" v-if="seldata.templateStatementType ==4">
                            <video controls :src="seldata.templateContent"></video>
                        </div>

                        <div class="selcon mp3con" v-if="seldata.templateStatementType ==3">
                            <audiopaly bg="hui" :mp3url="seldata.templateContent"></audiopaly>
                        </div>
                    </el-scrollbar>
                </div>
            </div>


        </el-dialog>
        <el-dialog :title="titlecon" :visible.sync="showaddteam" width="430px" :before-close="teamClose">
            <div class="addteambox">
                <label for="team">分组名称</label>
                <input id="team" type="text" maxlength="8" v-model="teamtxt">
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showaddteam = false">取 消</el-button>
                <el-button type="primary" @click="saveteam">确 定</el-button>
            </span>
        </el-dialog>

        <publicDialog class="settalkDialog" :dialogMain='dialogMain' :showData='showData' :activeName='activeName' :skillData='skillData'
            @saveSuccess='fatherSaveHandle'>
        </publicDialog>
    </div>
</template>

<script>
    import draggable from 'vuedraggable'
    import publicDialog from '@/components/publicDialog'
    import audiopaly from '@/components/mp3Play'
    import {
        insertDiscourseGroup,
        searchDiscourseGroup,
        deleteDiscourseGroup,
        deleteTemplateStatement,
        updateDiscourseGroup,
        sortDiscourseGroup,
        findTemplateStatementPage
    } from '@/utils/api-im.js'
    export default {
        name: 'addtalk',
        data() {
            return {
                bannerList1: [],
                talklistsdata: [],
                seldata: [],
                activeindexone: 0,
                activeindextwo: 0,
                showaddteam: false,
                showtalk: false,
                teamtxt: '',
                showData: {
                    grounpType: '', //0--新增 1--编辑
                },
                dialogMain: {
                    talkDialogVisible: false,
                    title: '',
                    type: '3',
                    width: '',
                    library:'3'

                },
                activeName: '',
                dialogSelect: '',
                skillData: '',
                titlecon: '',
                teamid: ''
            }
        },
        components: {
            draggable,
            audiopaly,
            publicDialog
        },

        props: {
            showaddtalk: ''
        },
        mounted() {
            this.getGroup(3)
        },
        methods: {

            dragend() {
                this.drag = false

                console.log(this.bannerList1)

                this.$post(sortDiscourseGroup, this.bannerList1).then(res => {
                    console.log(res.data)
                })
            },
            fatherSaveHandle(num,bool) {
                console.log('成功回调')
                this.skillData = ''
                this.dialogMain.talkDialogVisible = false
                this.showData.grounpType = ''
                this.activeName = ''
                switch (parseInt(num)) {
                    case 0:
                        // 添加话术分组成功
                        this.$toast('添加话术分组成功')
                        setTimeout(()=>{
                        // 刷新话术分组
                        this.getGroup(3)
                        },0)
                        break;
                    case 1:
                        // 编辑话术分组成功
                        this.$toast('编辑话术分组成功')
                        // 刷新话术分组
                        this.getGroup(3)
                        break;
                    case 2:
                        console.log(num)
                        // 添加话术模板成功
                        this.$toast('添加话术模板成功')
                        // 刷新模板列表
                        this.selone(this.activeindexone)
                        break;
                    case 3:
                        // 编辑话术模板成功
                        this.$toast('编辑话术模板成功')
                        // 刷新模板列表
                        this.selone(this.activeindexone,true)
                        if(!bool){
                            this.seldata = {}
                        }
                        break;

                    default:
                        break;
                }
            },
            teamClose() {
                this.showaddteam = false
                this.teamtxt = ''
            },

            addtalkfun() {
                if(this.bannerList1.length ==0){
                    this.$message.error('请添加分组');
                    return false
                }
                this.showtalk = true
                this.showData.grounpType = 3
                this.dialogMain = {
                    title: '添加话术',
                    talkDialogVisible: true,
                    type: '1',
                    width: '800px',
                    library:'3'
                }
                this.skillData = this.dialogSelect
                this.activeName = 3
                console.log('添加话术', this.dialogMain, this.activeName, this.showData)
            },

            addteam() {
                this.titlecon = '添加分组'
                this.showaddteam = true
                this.showtalk = true

            },

            saveteam() {
                this.showaddteam = false
                if (this.teamtxt != '') {

                    if (this.teamid) {
                        this.$post(updateDiscourseGroup, {
                            id: this.teamid,
                            name: this.teamtxt,
                            type: 3
                        }).then(res => {
                            if (res.data.code == 200) {
                                console.log(res.data)
                                this.getGroup(3)
                                this.teamid = ''
                            }else{
                                this.$message.error(res.data.msg);
                            }
                        })
                    } else {
                        this.$post(insertDiscourseGroup, {
                            "name": this.teamtxt,
                            "type": 3
                        }).then(res => {
                            console.log(res.data)
                            if (res.data.code == 200) {
                                this.getGroup(3)

                            }else{
                                this.$message.error(res.data.msg);
                            }

                        })
                    }

                }else{
                    this.$message.error('请输入分组名称');
                }
                this.teamtxt = ''

            },

            getGroup(type, str) {
                this.$post(searchDiscourseGroup, {
                    name: str,
                    type: type
                }).then((res) => {
                    console.log(res.data.data)
                    this.$post(searchDiscourseGroup, {
                        name: str,
                        type: type,
                        size:res.data.data.total
                    }).then((res) => {
                        console.log(res.data.data)
                        this.bannerList1 = res.data.data.records
                        this.dialogSelect = res.data.data.records.length
                    })
                })
            },

            handleClose() {
                this.$emit('closeaddtalkfun')
                let domainConfig = localStorage.getItem('userInfo')
                domainConfig = JSON.parse(domainConfig).domainConfig.crmDomain
                $('.frame')[0].contentWindow.postMessage({"type":"resettalk"},domainConfig);
            },
            reltype(url){
                let pos = url.lastIndexOf(".");
                let suffix = '';
                if (pos != -1) {
                    suffix = url.substring(pos);
                    console.log(suffix, 'suffix')
                    suffix = suffix.toLocaleLowerCase()
                }
                let type = ''
                if(suffix == '.doc'||suffix == '.docx'){
                  type =  'doc'
                }
                if(suffix == '.xls'||suffix == '.xlsx'){
                  type =  'xls'
                }
                if(suffix == '.ppt'||suffix == '.pptx'){
                  type =  'ppt'
                }
                if(suffix == '.pdf'){
                  type =  'pdf'
                }
                return type
            },
            selone(id,bool) {
                this.activeindexone = id

                this.talklistsdata = []
                this.loading = true
                this.$post(findTemplateStatementPage, {
                    discourseGroupId: id,
                    discourseGroupType: 3
                }).then(res => {
                    console.log(res.data.data)
                    if (res.data.code == 200) {
                        this.talklistsdata = res.data.data.resultList
                        for(let i =0;i<this.talklistsdata.length;i++){
                            if(this.talklistsdata[i].templateStatementType == 5){
                                let t = this.reltype(this.talklistsdata[i].templateContent)
                                this.talklistsdata[i].type = t
                            }
                        }
                    }
                    console.log(this.talklistsdata, 'talklistsdata')
                    this.loading = false
                    // for(let i =0;i<this.talklists.length;i++){
                    //     if(this.talklists[i].id = this.activeNames){
                    //         this.talklists.data=res.data.data.resultList
                    //     }
                    // }
                    if(bool){
                        this.seltwo(this.activeindextwo)
                    }
                })
            },
            seltwo(id) {
                this.activeindextwo = id
                for(let i = 0;i<this.talklistsdata.length;i++){
                    if(this.talklistsdata[i].id == id){
                        this.seldata = this.talklistsdata[i]
                    }
                }

                console.log(this.seldata)
            },

            editteam(id, txt) {
                console.log('editteam')
                this.titlecon = '编辑分组'
                this.showaddteam = true
                this.teamtxt = txt
                this.teamid = id
            },

            deletteam(id) {
                console.log('deletteam')
                this.$confirm('确定删除该分组吗？删除后将一并删除包含的所有话术。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',

                }).then(()=>{
                    this.$post(deleteDiscourseGroup+"?groupId="+id, {}).then(res => {
                        if (res.data.code == 200) {
                            console.log(res.data)
                            this.getGroup(3)
                            if(this.activeindexone == id){
                                this.talklistsdata = []
                                this.seldata = {}
                            }
                        }
                    })
                })

            },

            delettit(id) {
                this.$confirm('确定删除该话术吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(()=>{
                    this.$post(deleteTemplateStatement + "?id=" + id, {}).then(res => {
                        if (res.data.code == 200) {
                            console.log(res.data)
                            let ind = ''
                            for (let i = 0; i < this.talklistsdata.length; i++) {
                                if (this.talklistsdata[i].id == id) {
                                    ind = i
                                    if(this.activeindextwo == id){
                                        this.seldata = {}
                                    }
                                }
                            }
                            console.log(ind,'ind',this.talklistsdata)
                            this.talklistsdata.splice(ind, 1)
                            console.log('talklistsdata',this.talklistsdata)
                        }
                    })
                })

            },

            edittit(id, txt,index) {
                console.log('editteam')
                this.showData.grounpType =4
                this.showData.grouonpData =this.talklistsdata[index]
                this.dialogMain= {
                    title:'编辑话术',
                    talkDialogVisible:true,
                    type:'1',
                    width:'800px',
                    library:'3'
                }
                this.skillData = this.dialogSelect
                this.activeName = 3
            },
        }

    }
</script>

<style lang="less" scoped>

    .addteambox {
        font-size: 14px;
        color: #2A2A2A;

        label {
            margin: 0 10px 0 20px;
        }

        input {
            width: 240px;
            height: 32px;
            background: rgba(255, 255, 255, 1);
            border-radius: 2px;
            border: 1px solid rgba(218, 222, 224, 1);
            padding: 0 10px;
        }
    }

    .settlakbox {
        display: flex;
        border-radius: 3px;
        border: 1px solid rgba(220, 221, 223, 1);
        font-size: 14px;
        overflow: hidden;
        // padding: 10px;
        // margin: 0 10px;

        .selone {
            padding: 8px 0 40px 0px;
            height: 260px;
            position: relative;
            border-right: 1px solid rgba(220, 221, 223, 1);

            &:first-child{
                width: 230px;
            }

            &.seltwo {
                padding: 8px 0 40px 0px;
                width: 230px;
            }

            &.selthree {
                padding: 8px 0 8px 8px;
                flex: 1;
                border: none;
                height: 292px;
            }

            li,
            .lists {
                width: 230px;
                height: 36px;
                padding-right: 17px;
                line-height: 36px;
                cursor: pointer;

                &.active {
                    background: #0091FF;
                    color: #fff;
                }

                i {
                    display: inline-block;
                    height: 36px;
                    width: 30px;
                    text-align: center;
                }
            }
            .lists{
                height: 36px !important;
            }

            li {
                width: 218px;
                padding-left: 12px;
            }

            .selcon {
                margin: 14px 40px 14px 12px;
                background: rgba(249, 250, 252, 1);
                border-radius: 3px;
                line-height: 22px;
                font-size: 12px;
                cursor: pointer;
                margin-bottom: 10px;

                &.mp3con {
                    padding: 0;
                }

                &.imgcon,
                &.videocon {
                    padding: 0;
                    background: #fff;

                    img,
                    video {
                        max-width: 100%;
                    }

                }

                .txtcon {
                    max-height: 68px;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    background: #fff;
                }

                .filecon {
                    padding:12px 0 12px 68px;
                    position: relative;

                    b{
                        position: absolute;
                        top: 12px;
                        left: 12px;
                        font-size: 36px;
                        height: 44px;
                        line-height: 44px;
                    }

                    .doc{
                        color: #5DACFF;
                    }

                    .xls{
                        color: #5ACC9B;
                    }

                    .ppt{
                        color: #FF8A76;
                    }

                    .pdf{
                        color: #FF6969;
                    }

                    p {
                        font-size: 14px;
                        color: #2A2A2A;
                    }

                    span {
                        font-size: 12px;
                        color: #93999F;
                    }
                }
            }

            .addbtn {
                color: #0091FF;
                position: absolute;
                bottom: 0;
                left: 0;
                display: block;
                height: 36px;
                line-height: 36px;
                padding-left: 12px;
            }
        }
    }
</style>

<style lang="less" >
    .settalk {
        .el-dialog__header {
            padding: 20px 20px 10px;
        }
        .el-dialog__body {
            padding: 10px 20px 30px;
          }
    }
</style>



// WEBPACK FOOTER //
// src/views/customerservice/components/settalk.vue